import {
  Companion_getInstance3ribnrb9tntrx as Companion_getInstance,
  ServerFileWithMetadataPreviewcbfnnbup1q22 as ServerFileWithMetadataPreview,
} from './ServerFileWithMetadata.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../files/ServerFile.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareServerFileWithMetadataPreviewFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ServerFileWithMetadataPreview_file_getInstance(), ServerFileWithMetadataPreview_mimeType_getInstance(), ServerFileWithMetadataPreview_size_getInstance(), ServerFileWithMetadataPreview_width_getInstance(), ServerFileWithMetadataPreview_height_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function ServerFileWithMetadataPreview_file$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function ServerFileWithMetadataPreview_file$_get_name_$ref_mpnp7w() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadataPreview_file$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadataPreview_file$_get_serializer_$ref_a2ynjv() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadataPreview_file$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function ServerFileWithMetadataPreview_file$_get_annotations_$ref_qi0x9b() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadataPreview_fileClass;
function ServerFileWithMetadataPreview_file() {
  if (ServerFileWithMetadataPreview_fileClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadataPreview_file_instance = this;
        var tmp = this;
        tmp.l38_1 = lazy(ServerFileWithMetadataPreview_file$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m38_1 = lazy(ServerFileWithMetadataPreview_file$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n38_1 = lazy(ServerFileWithMetadataPreview_file$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.l38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadataPreview_file$_get_name_$ref_mpnp7w(), null);
        return tmp0.f2();
      }
      o38(receiver) {
        return receiver.p38_1;
      }
      k2j(receiver) {
        return new (ServerFile())(this.o38(receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE()));
      }
      u38(receiver, value) {
        return receiver.v38(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE();
        return this.u38(tmp, value instanceof ServerFile() ? value.l2n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadataPreview_file$_get_serializer_$ref_a2ynjv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadataPreview_file$_get_annotations_$ref_qi0x9b(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadataPreview_file', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadataPreview_fileClass = $;
  }
  return ServerFileWithMetadataPreview_fileClass;
}
var ServerFileWithMetadataPreview_file_instance;
function ServerFileWithMetadataPreview_file_getInstance() {
  if (ServerFileWithMetadataPreview_file_instance === VOID)
    new (ServerFileWithMetadataPreview_file())();
  return ServerFileWithMetadataPreview_file_instance;
}
function ServerFileWithMetadataPreview_mimeType$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function ServerFileWithMetadataPreview_mimeType$_get_name_$ref_avyag6() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadataPreview_mimeType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadataPreview_mimeType$_get_serializer_$ref_37c3rh() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadataPreview_mimeType$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function ServerFileWithMetadataPreview_mimeType$_get_annotations_$ref_qn3ss1() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadataPreview_mimeTypeClass;
function ServerFileWithMetadataPreview_mimeType() {
  if (ServerFileWithMetadataPreview_mimeTypeClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadataPreview_mimeType_instance = this;
        var tmp = this;
        tmp.w38_1 = lazy(ServerFileWithMetadataPreview_mimeType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x38_1 = lazy(ServerFileWithMetadataPreview_mimeType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y38_1 = lazy(ServerFileWithMetadataPreview_mimeType$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadataPreview_mimeType$_get_name_$ref_avyag6(), null);
        return tmp0.f2();
      }
      z38(receiver) {
        return receiver.q38_1;
      }
      k2j(receiver) {
        return this.z38(receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE());
      }
      a39(receiver, value) {
        return receiver.v38(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE();
        return this.a39(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadataPreview_mimeType$_get_serializer_$ref_37c3rh(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadataPreview_mimeType$_get_annotations_$ref_qn3ss1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadataPreview_mimeType', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadataPreview_mimeTypeClass = $;
  }
  return ServerFileWithMetadataPreview_mimeTypeClass;
}
var ServerFileWithMetadataPreview_mimeType_instance;
function ServerFileWithMetadataPreview_mimeType_getInstance() {
  if (ServerFileWithMetadataPreview_mimeType_instance === VOID)
    new (ServerFileWithMetadataPreview_mimeType())();
  return ServerFileWithMetadataPreview_mimeType_instance;
}
function ServerFileWithMetadataPreview_size$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function ServerFileWithMetadataPreview_size$_get_name_$ref_cfhsuf() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadataPreview_size$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadataPreview_size$_get_serializer_$ref_qenajk() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadataPreview_size$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function ServerFileWithMetadataPreview_size$_get_annotations_$ref_hnlick() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadataPreview_sizeClass;
function ServerFileWithMetadataPreview_size() {
  if (ServerFileWithMetadataPreview_sizeClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadataPreview_size_instance = this;
        var tmp = this;
        tmp.b39_1 = lazy(ServerFileWithMetadataPreview_size$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c39_1 = lazy(ServerFileWithMetadataPreview_size$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d39_1 = lazy(ServerFileWithMetadataPreview_size$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.b39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadataPreview_size$_get_name_$ref_cfhsuf(), null);
        return tmp0.f2();
      }
      z38(receiver) {
        return receiver.r38_1;
      }
      k2j(receiver) {
        return this.z38(receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE());
      }
      e39(receiver, value) {
        return receiver.v38(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE();
        return this.e39(tmp, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.c39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadataPreview_size$_get_serializer_$ref_qenajk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadataPreview_size$_get_annotations_$ref_hnlick(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadataPreview_size', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadataPreview_sizeClass = $;
  }
  return ServerFileWithMetadataPreview_sizeClass;
}
var ServerFileWithMetadataPreview_size_instance;
function ServerFileWithMetadataPreview_size_getInstance() {
  if (ServerFileWithMetadataPreview_size_instance === VOID)
    new (ServerFileWithMetadataPreview_size())();
  return ServerFileWithMetadataPreview_size_instance;
}
function ServerFileWithMetadataPreview_width$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function ServerFileWithMetadataPreview_width$_get_name_$ref_lwwdm0() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadataPreview_width$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadataPreview_width$_get_serializer_$ref_z8wlbl() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadataPreview_width$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function ServerFileWithMetadataPreview_width$_get_annotations_$ref_b3ogtv() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadataPreview_widthClass;
function ServerFileWithMetadataPreview_width() {
  if (ServerFileWithMetadataPreview_widthClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadataPreview_width_instance = this;
        var tmp = this;
        tmp.f39_1 = lazy(ServerFileWithMetadataPreview_width$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g39_1 = lazy(ServerFileWithMetadataPreview_width$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h39_1 = lazy(ServerFileWithMetadataPreview_width$annotations$delegate$lambda);
        this.i39_1 = null;
        this.j39_1 = 'null';
      }
      i20() {
        var tmp0 = this.f39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadataPreview_width$_get_name_$ref_lwwdm0(), null);
        return tmp0.f2();
      }
      z38(receiver) {
        return receiver.s38_1;
      }
      k2j(receiver) {
        return this.z38(receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE());
      }
      k39(receiver, value) {
        return receiver.v38(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE();
        return this.k39(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadataPreview_width$_get_serializer_$ref_z8wlbl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadataPreview_width$_get_annotations_$ref_b3ogtv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadataPreview_width', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadataPreview_widthClass = $;
  }
  return ServerFileWithMetadataPreview_widthClass;
}
var ServerFileWithMetadataPreview_width_instance;
function ServerFileWithMetadataPreview_width_getInstance() {
  if (ServerFileWithMetadataPreview_width_instance === VOID)
    new (ServerFileWithMetadataPreview_width())();
  return ServerFileWithMetadataPreview_width_instance;
}
function ServerFileWithMetadataPreview_height$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function ServerFileWithMetadataPreview_height$_get_name_$ref_zgml0f() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadataPreview_height$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadataPreview_height$_get_serializer_$ref_rj85ru() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadataPreview_height$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function ServerFileWithMetadataPreview_height$_get_annotations_$ref_ex0r92() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadataPreview_heightClass;
function ServerFileWithMetadataPreview_height() {
  if (ServerFileWithMetadataPreview_heightClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadataPreview_height_instance = this;
        var tmp = this;
        tmp.l39_1 = lazy(ServerFileWithMetadataPreview_height$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m39_1 = lazy(ServerFileWithMetadataPreview_height$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n39_1 = lazy(ServerFileWithMetadataPreview_height$annotations$delegate$lambda);
        this.o39_1 = null;
        this.p39_1 = 'null';
      }
      i20() {
        var tmp0 = this.l39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadataPreview_height$_get_name_$ref_zgml0f(), null);
        return tmp0.f2();
      }
      z38(receiver) {
        return receiver.t38_1;
      }
      k2j(receiver) {
        return this.z38(receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE());
      }
      k39(receiver, value) {
        return receiver.v38(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadataPreview() ? receiver : THROW_CCE();
        return this.k39(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadataPreview_height$_get_serializer_$ref_rj85ru(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n39_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadataPreview_height$_get_annotations_$ref_ex0r92(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadataPreview_height', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadataPreview_heightClass = $;
  }
  return ServerFileWithMetadataPreview_heightClass;
}
var ServerFileWithMetadataPreview_height_instance;
function ServerFileWithMetadataPreview_height_getInstance() {
  if (ServerFileWithMetadataPreview_height_instance === VOID)
    new (ServerFileWithMetadataPreview_height())();
  return ServerFileWithMetadataPreview_height_instance;
}
//region block: exports
export {
  prepareServerFileWithMetadataPreviewFields as prepareServerFileWithMetadataPreviewFields1uah4xzwvf5za,
};
//endregion

//# sourceMappingURL=ServerFileWithMetadataPreviewFields.mjs.map
